export enum ScheduledTask {
    billingExportStudyReport = 1,
    billingExportImages = 2,
    billingPreBilling = 3,
    billingValidationOnLine = 4,
    exportAttached = 5
}
